import BaseService from "./base-service";
import axios from "axios";
import {SCHEMA} from "./endpoints";
import * as SomlUtils from "../utils/soml-utils";
import {Schema} from "../types/Schema";

/**
 * Service for storing and fetching uploaded SOML schemas from the workbench server. Not to be
 * confused with the semantic object service.
 */
export default class SchemaUploadService extends BaseService {

  /**
   * Uploads the supplied SOML schema file to the workbench server.
   *
   * @param {File} schema - the schema to upload
   * @param {(event: ProgressEvent) => void} progressCallback a callback function for upload progress
   * @returns {Promise<string>} promise resolving with the uploaded schema
   */
  static upload(schema: File, progressCallback: (event: ProgressEvent) => void): Promise<string> {
    const formData = new FormData();
    formData.append('file', schema);

    return axios.post(`${SCHEMA}/upload`, formData, {
      onUploadProgress: progressEvent => progressCallback(progressEvent)
    }).then(this.resolveResponse);
  }

  /**
   * Downloads previously uploaded SOML schema file from the workbench server.
   *
   * @param {string} filePath - the SOML file that was uploaded
   * @returns {Promise<Schema>} promise resolving to a Schema object
   */
  static download(filePath: string): Promise<Schema> {
    const encodedPath = encodeURIComponent(filePath);

    return axios.get(`${SCHEMA}/${encodedPath}`, {
      // Avoid transforming JSON to js object
      transformResponse: [data => data],
    }).then(this.resolveResponse)
      .then(SomlUtils.parseSchemaYaml);
  }
}
